import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import { Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';

import DropdownIcon from 'components/svg/Dropdown';
import './FeeWarningToolTip.scss';

// Enhancer with recompose
const enhance = compose(
	withProps(({ feeProps }) => {
		let fees = [
			{
				name: 'One-Time Admin Fee',
				price: feeProps?.admin?.value,
			},
			{
				name: 'One-Time Lock Fee',
				price: feeProps?.lock?.value,
			},
		];

		const totalFees = feeProps?.totalFees.value;

		fees = fees.filter((fee) => fee.price > 0);

		return {
			fees,
			totalFees,
		};
	})
);

function FeeWarningToolTip({ fees, totalFees, className, triggerAlignment = 'center', variation = false }) {
	return (
		<Tooltip
			className={classnames('tooltip-banner', className)}
			content={
				<Text
					size="tiny"
					color="gray"
				>
					The following fees shall apply:
					{fees && (
						<ul>
							{fees.map((fee) => (
								<li key={fee.name}>
									{`${fee.name}: $${fee.price}`}
								</li>
							))}
						</ul>
					)}
				</Text>
			}
			clickOnMobile
			fillParentContainer={triggerAlignment}
			simpleButton
			as="div"
		>
			<Text last size="tiny" color={variation ? 'black' : 'gray'} className="total-fee-text" weight={variation ? 'bold' : 'standard'}>
				+ ${totalFees} in fees <DropdownIcon />
			</Text>
		</Tooltip>
	);
}

FeeWarningToolTip.propTypes = {
	fees: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			price: PropTypes.number,
		})
	).isRequired,
	totalFees: PropTypes.number.isRequired,
	className: PropTypes.string,
	triggerAlignment: PropTypes.string,
	variation: PropTypes.bool
};

export default enhance(FeeWarningToolTip);
